import styled from "@emotion/styled";
import Colors from "styles/colors";
import { SUBMENU_BORDER, sectionHeaderStyles, textLinkItemStyles } from "../submenu-shared.scss";
export const StyledResourcesSubmenuComponent = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors["white"]};

  .section-header {
    ${sectionHeaderStyles}
  }

  .resources-section {
    padding: 25px 0;
    flex-shrink: 0;
    border-top: ${SUBMENU_BORDER};
    display: flex;
    flex-direction: column;
    gap: 8px;

    &:first-child {
      padding: 32px 0;
      border-top: none;
    }
  }

  .text-item {
    ${textLinkItemStyles}
  }
`;
